import React from 'react';
import { FieldPattern } from '..';

import { PHONE } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class PhoneNumberField extends FormFieldWithInitialValue {
  readonly type: string = PHONE;
  fieldType: string;
  shouldShowIcon: boolean;
  focusIcon: React.FC<any> | undefined;
  isFieldDisabled = false;
  reRenderedFields: Array<string>;
  shouldShowOtpField: boolean;
  pattern: string;
  getOtpButtonActions: Array<string>;
  shouldShowUpdateOption: boolean;
  buttonText?: string;
  buttonAction?: () => void;

  constructor(
    textFieldData: FormFieldsType,
    initialValue = '',
    fieldType = 'text',
    shouldShowIcon = false,
    focusIcon?: React.FC<any>,
    reRenderedFields: Array<string> = []
  ) {
    super(textFieldData, initialValue);
    this.fieldType = fieldType;
    this.shouldShowIcon = shouldShowIcon;
    this.focusIcon = focusIcon;
    this.isFieldDisabled = initialValue ? true : false;
    this.reRenderedFields = reRenderedFields;
    this.shouldShowOtpField = textFieldData.should_show_otp_field ?? false;
    this.shouldShowUpdateOption =
      textFieldData.should_show_update_option ?? false;
    this.pattern = textFieldData.pattern ? textFieldData.pattern : '';
    this.getOtpButtonActions = textFieldData.get_otp_button_actions ?? [];
    this.buttonText = (textFieldData as any).buttonText;
    this.buttonAction = (textFieldData as any).buttonAction;
  }
  match<T>(p: FieldPattern<T>): T {
    return p.PhoneNumberField(this);
  }
}

export default PhoneNumberField;
